import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import "./Assets/Fonts/Poppins-Bold.ttf"
import "./Assets/Fonts/Poppins-BoldItalic.ttf"
import "./Assets/Fonts/Poppins-Medium.ttf"
import "./Assets/Fonts/Poppins-MediumItalic.ttf"
import "./Assets/Fonts/Poppins-Regular.ttf"
import "./Assets/Fonts/Poppins-SemiBold.ttf"
import "./Assets/Fonts/Poppins-SemiBoldItalic.ttf"

import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

